import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PostManagementDetailComponent = lazy(
  () => import('@components/Group/Portfolio/PostManagementDetail')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 사후관리 상세 */
const PostManagementDetail = () => {
  return (
    <ApiErrorBoundary>
      <Suspense>
        <PostManagementDetailComponent />
      </Suspense>
    </ApiErrorBoundary>
  );
};

export default PostManagementDetail;
